
(() => {
  function initProductCard(card) {
    const selector = card.querySelector('[data-product-variants]');

    if (!selector || selector.dataset.initialized === 'true') return;

    const data = selector.querySelector('[data-variant-data]');
    if (!data) return;

    let variants;

    try {
      variants = JSON.parse(data.textContent);
    } catch (error) {
      console.error('Unable to read product variants:', error);
      return;
    }

    const selects = [
      ...selector.querySelectorAll('select[data-option-index]')
    ];

    const quickAddElements = [
      ...card.querySelectorAll('quick-add-button')
    ];

    const buttons = [
      ...card.querySelectorAll('quick-add-button button')
    ];

    const error = selector.querySelector('.product-card-variant-error');

    function updateVariant() {
      const selectedOptions = selects.map(select => select.value);

      const variant = variants.find(item =>
        item.options.every((option, index) =>
          option === selectedOptions[index]
        )
      );

      if (!variant) {
        quickAddElements.forEach(element => {
          element.removeAttribute('variant-id');
        });

        buttons.forEach(button => {
          button.disabled = true;
          button.textContent = 'UNAVAILABLE';
        });

        if (error) error.hidden = false;
        return;
      }

      quickAddElements.forEach(element => {
        element.setAttribute('variant-id', variant.id);
      });

      buttons.forEach(button => {
        button.disabled = !variant.available;
        button.textContent = variant.available
          ? 'ADD TO CART'
          : 'SOLD OUT';
      });

      if (error) error.hidden = variant.available;
    }

    selects.forEach(select => {
      select.addEventListener('change', updateVariant);
    });

    selector.dataset.initialized = 'true';
    updateVariant();
  }

  function initAll(root = document) {
    if (root.matches?.('.product-card')) {
      initProductCard(root);
    }

    root.querySelectorAll?.('.product-card').forEach(initProductCard);
  }

  function start() {
    initAll();

    document.addEventListener('shopify:section:load', event => {
      initAll(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
